// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__262Ba","footerCol":"Footer_footerCol__NF6wJ","footerLogo":"Footer_footerLogo__wnlm0","footerLogoText":"Footer_footerLogoText__Yp9hO"};